module.exports = __webpack_public_path__ + "1a71ee2232c637e72007f0f368aaa8db.png";